'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _AsyncData = require('conversations-async-data/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _requestFailed = require('conversations-async-data/async-data/operators/requestFailed');

var _requestStarted = require('conversations-async-data/async-data/operators/requestStarted');

var _requestSucceededWithOperator = require('conversations-async-data/async-data/operators/requestSucceededWithOperator');

var _IndexedAsyncData = require('conversations-async-data/indexed-async-data/IndexedAsyncData');

var _IndexedAsyncData2 = _interopRequireDefault(_IndexedAsyncData);

var _updateEntry = require('conversations-async-data/indexed-async-data/operators/updateEntry');

var _getSendFrom = require('conversations-schema/operators/widget-data/getSendFrom');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _asyncActionTypes = require('../constants/asyncActionTypes');

var _buildResponderKey = require('../operators/buildResponderKey');

var _responderKeyInvariant = require('../operators/responderKeyInvariant');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _IndexedAsyncData2.default)({
  name: 'responders',
  idInvariant: _responderKeyInvariant.responderKeyInvariant,
  idTransform: function idTransform(id) {
    return id;
  },
  notSetValue: (0, _AsyncData2.default)({
    data: null
  })
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.GET_WIDGET_DATA_SUCCEEDED, function (responders, action) {
  var payload = action.payload;


  var botResponderList = payload.botResponder ? (0, _immutable.List)([payload.botResponder]) : (0, _immutable.List)();
  var allResponders = botResponderList.concat((0, _getSendFrom.getSendFrom)(payload));
  return allResponders.reduce(function (respondersMap, newResponder) {
    var id = (0, _buildResponderKey.buildResponderKeyFromResponder)(newResponder);
    return (0, _updateEntry.updateEntry)(id, (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
      return newResponder;
    }), respondersMap);
  }, responders);
}), _defineProperty(_handleActions, ActionTypes.GET_VISITOR_THREADS_SUCCESS, function (responders, action) {
  var threads = action.payload.threads;

  var threadResponders = [];
  threads.forEach(function (thread) {
    var responder = (0, _threadGetters.getResponder)(thread);
    if (responder) {
      threadResponders.push(responder);
    }
  });
  return threadResponders.reduce(function (respondersMap, newResponder) {
    var id = (0, _buildResponderKey.buildResponderKeyFromResponder)(newResponder);
    return (0, _updateEntry.updateEntry)(id, (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
      return newResponder;
    }), respondersMap);
  }, responders);
}), _defineProperty(_handleActions, _asyncActionTypes.FETCH_AGENT_RESPONDER.STARTED, function (responders, _ref) {
  var payload = _ref.payload;

  var id = (0, _buildResponderKey.buildResponderKeyFromRequest)(payload.requestArgs);
  return (0, _updateEntry.updateEntry)(id, _requestStarted.requestStarted, responders);
}), _defineProperty(_handleActions, _asyncActionTypes.FETCH_AGENT_RESPONDER.FAILED, function (responders, _ref2) {
  var payload = _ref2.payload;

  var id = (0, _buildResponderKey.buildResponderKeyFromRequest)(payload.requestArgs);
  return (0, _updateEntry.updateEntry)(id, _requestFailed.requestFailed, responders);
}), _defineProperty(_handleActions, _asyncActionTypes.FETCH_AGENT_RESPONDER.SUCCEEDED, function (responders, _ref3) {
  var payload = _ref3.payload;

  var id = (0, _buildResponderKey.buildResponderKeyFromRequest)(payload.requestArgs);
  return (0, _updateEntry.updateEntry)(id, (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
    return payload.data;
  }), responders);
}), _handleActions), initialState);
module.exports = exports['default'];